import React, { Component } from 'react';
import createReactClass from 'create-react-class';
import _ from 'lodash';
import Carousel from 'nuka-carousel';
import { breakSmall } from '../../../const';
import './Caro.css';



/**
 * Caro
 * @constructor
 * @param {prop} data - Items
 * @param {prop} respSlidesToShow - Responsive Slides to Show
 * @param {prop} slidesToShow - Slides to Show
 * @param {prop} frameOverflow - Show Overflow
 * @param {prop} data - Items
 */

class Caro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      slidesToShow: window.innerWidth < breakSmall ? props.respSlidesToShow : props.slidesToShow,
      slidesToScroll: props.slidesToScroll,
      slideIndex: 0
    };

 
  }
  componentDidMount(){
    window.addEventListener('resize', this.onResize, false);
    this.throttledResize = _.throttle(this.throttledResize.bind(this), 500);
  }
  componentWillUnmount(){
    window.removeEventListener('resize', this.onResize, false);
  }

  /**
  * Tied to the resize event on window
  */
  onResize = (e) => {
    this.throttledResize(e);
  }
  /**
  * Throttled resize function, handles resetting slidesToShow count
  */
  throttledResize = (e) => {
    const { respSlidesToShow, slidesToShow, slidesToScroll } = this.props;
    this.setState({
      slidesToShow: window.innerWidth < breakSmall ? respSlidesToShow : slidesToShow
    });
  }

  render() {
    const { slidesToShow, slidesToScroll } = this.state;
    const { frameOverflow, framePadding, insertClass, cellSpacing, color, cellAlign } = this.props;
    return (
      <div className={'caro '+ insertClass +' mod-'+color}>
   
        <Carousel
          scrollMode='page'
          frameOverflow={''+frameOverflow+''}
          framePadding={framePadding}
          cellSpacing={cellSpacing}
          slidesToShow={slidesToShow}
          slidesToScroll={slidesToScroll}
          slideIndex={this.state.slideIndex}
          afterSlide={slideIndex => this.setState({ slideIndex })}
          cellAlign={cellAlign ? cellAlign : 'left'}
          renderCenterLeftControls={({ previousSlide }) => {
            if(this.state.slideIndex > 0){
              return(
                <button
                  className='caro-transport caro-transport-prev'
                  onClick={previousSlide}>
                  <svg viewBox="0 0 10.55 17.43"><path className="cls-1" d="M1.23,3.06,8,9.79,1.23,16.52a.51.51,0,0,0,0,.72l1.11,1.12a.51.51,0,0,0,.72,0l8.57-8.57L3.06,1.23a.51.51,0,0,0-.72,0L1.23,2.34A.51.51,0,0,0,1.23,3.06Z" transform="translate(-1.08 -1.08)"/>
                  </svg>
                </button>
              )
            }
          }}
          renderCenterRightControls={({ nextSlide }) => {
              if(this.state.slideIndex < this.props.children.length - 1 ){
                return(
                  <button
                    className='caro-transport caro-transport-next'
                    onClick={nextSlide}>
                    <svg viewBox="0 0 10.55 17.43"><path className="cls-1" d="M1.23,3.06,8,9.79,1.23,16.52a.51.51,0,0,0,0,.72l1.11,1.12a.51.51,0,0,0,.72,0l8.57-8.57L3.06,1.23a.51.51,0,0,0-.72,0L1.23,2.34A.51.51,0,0,0,1.23,3.06Z" transform="translate(-1.08 -1.08)"/>
                    </svg>
                  </button>
                )
              }    
          }}
          >
          { this.props.children }
        </Carousel>
      </div>
    );
  }
}

export default Caro;



// WEBPACK FOOTER //
// ./src/components/Carousels/Caro/Caro.js